var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 44.458,
    viewBox: "0 0 24 44.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-animated",
    transform: "translate(-8.342 68.249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-rectangle_to",
    transform: "translate(8.342 -55.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-rectangle",
    d: "M38.918,17.2h4a.422.422,0,0,1,.423.423V21.5a.422.422,0,0,1-.423.423h-4A.422.422,0,0,1,38.5,21.5V17.623A.413.413,0,0,1,38.918,17.2Z",
    transform: "translate(-38.495 -17.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-rectangle-2_to",
    transform: "translate(8.342 -45.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-rectangle-2",
    d: "M38.918,81.8h4a.422.422,0,0,1,.423.423v20.965a.422.422,0,0,1-.423.423h-4a.422.422,0,0,1-.423-.423V82.238A.416.416,0,0,1,38.918,81.8Z",
    transform: "translate(-38.495 -81.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-rectangle-3_to",
    transform: "translate(27.497 -55.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-rectangle-3",
    d: "M165.823,17.2h4a.422.422,0,0,1,.423.423v5.056a.422.422,0,0,1-.423.423h-4a.422.422,0,0,1-.423-.423V17.623A.422.422,0,0,1,165.823,17.2Z",
    transform: "translate(-165.4 -17.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-rectangle-4_to",
    transform: "translate(27.497 -44.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-rectangle-4",
    d: "M165.823,89.7h4a.422.422,0,0,1,.423.423V96.6a.422.422,0,0,1-.423.423h-4a.422.422,0,0,1-.423-.423V90.123A.413.413,0,0,1,165.823,89.7Z",
    transform: "translate(-165.4 -89.7)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-rectangle-5_to",
    transform: "translate(17.912 -55.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-rectangle-5",
    d: "M102.323,17.2h4a.422.422,0,0,1,.423.423v8.905a.422.422,0,0,1-.423.423h-4a.422.422,0,0,1-.423-.423V17.623A.432.432,0,0,1,102.323,17.2Z",
    transform: "translate(-101.9 -17.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-rectangle-6_to",
    transform: "translate(17.912 -40.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-rectangle-6",
    d: "M102.323,114.7h4a.422.422,0,0,1,.423.423v6.294a.422.422,0,0,1-.423.423h-4a.422.422,0,0,1-.423-.423v-6.294A.432.432,0,0,1,102.323,114.7Z",
    transform: "translate(-101.9 -114.7)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g1_to",
    transform: "translate(8.584 -68.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g1",
    transform: "translate(0 0)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-path1",
    d: "M40.1,166.894a2.177,2.177,0,1,1,4.347,0v4.739a2.177,2.177,0,1,1-4.347,0Zm1.434,4.83c0,.649.287.906.74.906s.74-.242.74-.906V166.8s-.287-.906-.74-.906-.74.242-.74.906Z",
    transform: "translate(-40.1 -164.6)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g2_to",
    transform: "translate(27.738 -68.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g2",
    transform: "translate(0)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-path2",
    d: "M167,4.294a2.177,2.177,0,1,1,4.347,0V9.034a2.177,2.177,0,1,1-4.347,0V4.294Zm1.434,4.83c0,.649.287.906.74.906s.74-.241.74-.906V4.2c0-.649-.287-.906-.74-.906s-.74.241-.74.906Z",
    transform: "translate(-167 -2)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g3_to",
    transform: "translate(18.169 -68.249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g3",
    transform: "translate(0 0)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-path3",
    d: "M103.6,109.794a2.177,2.177,0,1,1,4.347,0v4.739a2.177,2.177,0,1,1-4.347,0Zm1.419,4.83c0,.649.287.906.74.906s.74-.242.74-.906V109.7c0-.649-.287-.906-.74-.906s-.74.242-.74.906Z",
    transform: "translate(-103.6 -107.5)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g4_to",
    transform: "translate(8.962 -68.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g4",
    transform: "translate(0 0)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-path4",
    d: "M42.6,84.947A1.4,1.4,0,0,0,44.17,83.8h.966v9.117H43.7V85.958H42.6Z",
    transform: "translate(-42.6 -83.8)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g5_to",
    transform: "translate(18.712 -68.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g5",
    transform: "translate(0 0)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-path5",
    d: "M107.2,20.447a1.4,1.4,0,0,0,1.57-1.147h.966v9.117H108.3V21.458h-1.1Z",
    transform: "translate(-107.2 -19.3)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g6_to",
    transform: "translate(28.116 -68.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g6",
    transform: "translate(0 0)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-path6",
    d: "M169.5,89.147A1.4,1.4,0,0,0,171.07,88h.966v9.117H170.6V90.158h-1.1Z",
    transform: "translate(-169.5 -88)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g7_to",
    transform: "translate(8.584 -68.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g7",
    transform: "translate(0)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-path7",
    d: "M40.1,4.294a2.177,2.177,0,1,1,4.347,0V9.034a2.177,2.177,0,1,1-4.347,0V4.294Zm1.434,4.83c0,.649.287.906.74.906s.74-.241.74-.906V4.2c0-.649-.287-.906-.74-.906s-.74.241-.74.906Z",
    transform: "translate(-40.1 -2)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/adminIcon.a21c592c9bd7e6563ef10ea3bd7846b2.svg";
export { ForwardRef as ReactComponent };